import {selector} from './selector';
import * as events from "./events";

const PageCustomerProfileInfo = (function ($) {

    function initEvents() {
        $(document).on('click', selector.oldPasswordVisibility, events.changeVisibilityOldPassword);
        $(document).on('click', selector.newPasswordVisibility, events.changeVisibilityNewPassword);
        $(document).on('click', selector.newPasswordConfirmVisibility, events.changeVisibilityNewPasswordConfirm);
    }

    function initialize() {
        initEvents();
    }

    return {
        init: initialize
    }
})(jQuery);

export {PageCustomerProfileInfo};